export enum PostOfferModalType {
    DecisionPending = 1,
    DecisionFinalized = 2
}
